import { watch, ref, onUnmounted } from 'vue'

import { useFormStore } from '@/stores/form'

const watchReasonCategoriesAutoComplete = () => {
  const reasonCategoriesAutoCompleteWatch = ref()
  const formStore = useFormStore()

  reasonCategoriesAutoCompleteWatch.value = watch(
    () => formStore.form.values.reasonCategoriesAutoComplete,
    (newVal) => {
      formStore.form.setValues({
        refundReasonCategoryIds: newVal.toString()
      })
    }
  )
  onUnmounted(() => {
    reasonCategoriesAutoCompleteWatch.value && reasonCategoriesAutoCompleteWatch.value()
  })
}

const watchExemptReasonCategoriesAutoComplete = () => {
  const exemptReasonCategoriesAutoCompleteWatch = ref()
  const formStore = useFormStore()

  exemptReasonCategoriesAutoCompleteWatch.value = watch(
    () => formStore.form.values.exemptReasonCategoriesAutoComplete,
    (newVal) => {
      formStore.form.setValues({
        exemptReasonCategoryIds: newVal.toString()
      })
    }
  )
  onUnmounted(() => {
    exemptReasonCategoriesAutoCompleteWatch.value && exemptReasonCategoriesAutoCompleteWatch.value()
  })
}
export default function () {
  return {
    watchReasonCategoriesAutoComplete,
    watchExemptReasonCategoriesAutoComplete
  }
}
